import { Route } from '@angular/router';

export const ComponentsRoutes: Route[] = [
  {
    path: 'components',
    children: [
      {
        path: 'data-grid',
        loadComponent: () =>
          import('../pages/components/data-grid/data-grid.page'),
      },
      {
        path: 'calendar',
        loadComponent: () =>
          import('../pages/components/calendar/calendar.page'),
      },
      {
        path: 'alert',
        loadComponent: () => import('../pages/components/alert/alert.page'),
      },
      {
        path: 'common',
        loadComponent: () => import('../pages/components/common/common.page'),
      },
    ],
  },
];
